module.exports = __webpack_public_path__ + "static/media/logo.09262c78.svg";